// Stub for headwind-generated lib/styled
// Normally generated by @soltalabs/react.headwind-cli — we provide a minimal runtime stub
// that maps tailwind-like utility classes to CSS style objects.

import styledComponents from 'styled-components'

// Minimal tailwind-like utility → CSS mapping. Extend as needed.
const UNIT = 4 // 1 unit = 4px (tailwind default)

const parseUtility = (cls) => {
  // Basic mappings — extend as errors surface
  const map = {
    // flex / display
    flex: { display: 'flex' },
    'flex-1': { flex: 1 },
    'flex-column': { flexDirection: 'column' },
    'flex-row': { flexDirection: 'row' },
    block: { display: 'block' },
    'inline-block': { display: 'inline-block' },
    hidden: { display: 'none' },

    // align/justify
    'items-center': { alignItems: 'center' },
    'items-start': { alignItems: 'flex-start' },
    'items-end': { alignItems: 'flex-end' },
    'justify-center': { justifyContent: 'center' },
    'justify-between': { justifyContent: 'space-between' },
    'justify-around': { justifyContent: 'space-around' },
    'justify-start': { justifyContent: 'flex-start' },
    'justify-end': { justifyContent: 'flex-end' },

    // sizing
    'h-full': { height: '100%' },
    'w-full': { width: '100%' },
    'h-screen': { height: '100vh' },
    'w-screen': { width: '100vw' },

    // position
    relative: { position: 'relative' },
    absolute: { position: 'absolute' },
    fixed: { position: 'fixed' },

    // text
    'text-center': { textAlign: 'center' },
    'text-left': { textAlign: 'left' },
    'text-right': { textAlign: 'right' },
    'text-xs': { fontSize: '0.75rem' },
    'text-sm': { fontSize: '0.875rem' },
    'text-base': { fontSize: '1rem' },
    'text-lg': { fontSize: '1.125rem' },
    'text-xl': { fontSize: '1.25rem' },
    'text-2xl': { fontSize: '1.5rem' },
    'text-3xl': { fontSize: '1.875rem' },

    // misc
    'cursor-pointer': { cursor: 'pointer' },
    'overflow-hidden': { overflow: 'hidden' },
    'overflow-auto': { overflow: 'auto' },
  }

  if (map[cls]) return map[cls]

  // Spacing: m-*, p-*, mt-*, mb-*, ml-*, mr-*, mx-*, my-*, pt-*, pb-*, pl-*, pr-*, px-*, py-*
  const spacing = cls.match(/^([mp])([trblxy]?)-(\d+|auto)$/)
  if (spacing) {
    const [, type, side, val] = spacing
    const prop = type === 'm' ? 'margin' : 'padding'
    const value = val === 'auto' ? 'auto' : `${parseInt(val, 10) * UNIT}px`
    const sideMap = {
      t: 'Top',
      b: 'Bottom',
      l: 'Left',
      r: 'Right',
      x: ['Left', 'Right'],
      y: ['Top', 'Bottom'],
      '': '',
    }
    const s = sideMap[side]
    if (Array.isArray(s)) {
      return { [`${prop}${s[0]}`]: value, [`${prop}${s[1]}`]: value }
    }
    return { [`${prop}${s}`]: value }
  }

  // Unhandled — log for debugging but don't break
  return {}
}

// s() accepts: space-separated utility classes, optional style object, returns merged style object
export const s = (...args) => {
  let result = {}
  args.forEach((arg) => {
    if (typeof arg === 'string') {
      arg.split(/\s+/).filter(Boolean).forEach((cls) => {
        Object.assign(result, parseUtility(cls))
      })
    } else if (typeof arg === 'object' && arg !== null) {
      Object.assign(result, arg)
    }
  })
  return result
}

// Re-export styled-components' styled
export const styled = styledComponents
export default styledComponents
